import { firestoreAction  } from 'vuexfire'
import { db } from '@/data/db'
import { generateCode, shuffleArray } from '@/utils'
import { Deck } from '@/models/data/LoveLetter'

export default {
    namespaced: true,
    state: {
        code: null,
        username: null,
        game: null,
        players: [],
        cards: [],
        selectedCard: null,
        selectedPlayerId: null,
    },
    mutations: {
        UPDATE_USERNAME: (state, value) => state.username = value,
        UPDATE_CODE: (state, value) => state.code = value,
        UPDATE_SELECTEDCARD: (state, value) => state.selectedCard = value,
        UPDATE_SELECTEDPLAYERID: (state, value) => state.selectedPlayerId = value,
        drawCard: (state) => state.game.deck.splice(0,1)[0]
    },
    actions: {
        bindGame: firestoreAction((context) => {
            return context.bindFirestoreRef('game', context.getters.gameRef)
        }),
        bindPlayers: firestoreAction((context) => {
            return context.bindFirestoreRef('players', context.getters.playersRef)
        }),
        addGame: firestoreAction((context) => {
            return context.getters.gamesRef.doc(context.state.code).set({
                deck: [],
                status: 'lobby',
                round: 0,
                leader: context.state.username
            })
        }),
        addPlayer: firestoreAction((context) => {
            return context.getters.playersRef.doc(context.state.username).set({
                activeCards: [],
                playedCards: [],
                isAlive: true
            })
        }),
        updateGame: firestoreAction((context, game) => {
            return context.getters.gameRef.update(game)
        }),
        updatePlayer: firestoreAction((context, player) => {
            let id = player.id;
            delete player.id;
            return context.getters.playersRef.doc(id).update(player)
        }),
        JoinGame: async ({ getters, state, dispatch }) => {
            await getters.gamesRef.doc(state.code).get()
                .then(async (snapshot) => {
                    if (!snapshot.exists) throw new Error('Game does not exist')
                    else await dispatch('addPlayer', state.username)
                })
        },
        StartNewGame: async ({ commit, dispatch }) => {
            let code = generateCode()
            commit('UPDATE_CODE', code);
            await dispatch('addGame')
            await dispatch('addPlayer')
        },
        StartNewRound: async({ state, dispatch }) => {
            let deck = [...Deck]
            let drawCard = () => deck.splice(0, 1)[0]
            shuffleArray(deck)
            await Promise.all([...state.players].map(async (player) => {
                await dispatch('updatePlayer', {
                    id: player.id,
                    activeCards: [drawCard()],
                    playedCards: [],
                    isAlive: true
                })
            }))
            let mysteryCard =  drawCard()
            await dispatch('updateGame', {
                status: "started",
                mysteryCard: mysteryCard,
                deck: deck,
                round: state.game.round + 1 || 1
            })
        },
        DrawCard: async({ state, getters, dispatch }) => {
            let activeCards = getters.player.activeCards;
            activeCards.push(state.game.deck.splice(0, 1)[0])
            await dispatch('updatePlayer', {
                id: getters.player.id,
                activeCards: activeCards
            })
            await dispatch('updateGame', {
                deck: state.game.deck
            })
        },
        PlayCard: async({ state, getters, commit, dispatch }) => {
            if (state.selectedCard == null) return;
            getters.player.playedCards.push(getters.player.activeCards.splice(state.selectedCard, 1)[0])
            commit('UPDATE_SELECTEDCARD', null)
            await dispatch('updatePlayer', {
                id: getters.player.id,
                playedCards: getters.player.playedCards,
                activeCards: getters.player.activeCards
            })
        },
        PutCardUnderDeck: async({ state, getters, commit, dispatch }) => {
            if (state.selectedCard == null) return;
            state.game.deck.push(getters.player.activeCards.splice(state.selectedCard, 1)[0])
            commit('UPDATE_SELECTEDCARD', null)
            await dispatch('updatePlayer', {
                id: getters.player.id,
                activeCards: getters.player.activeCards
            }),
            await dispatch('updateGame', {
                deck: state.game.deck
            })
        },
        SwitchDeadStatus: async({ getters, dispatch }) => {
            await dispatch('updatePlayer', {
                id: getters.player.id,
                isAlive: !getters.player.isAlive
            })
        }
    },
    getters: {
        gamesRef: () => {
            return db.collection('love-letter')
        },
        gameRef: (state, getters) => {
            if (state.code == null) return null;
            return getters.gamesRef.doc(state.code)
        },
        playersRef: (state, getters) => {
            if (state.code == null) return null;
            return getters.gameRef.collection('players')
        },
        isLeader: (state) => {
            if (state.game == null) return false;
            return state.username == state.game.leader
        },
        player: (state) => {
            return state.players.find((p) => p.id == state.username)
        },
        selectedPlayer: (state) => {
            return state.players.find((p) => p.id == state.selectedPlayerId)
        }
    },
    
}
